"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const ApiUtil_1 = __importDefault(require("../util/ApiUtil"));
const TextUtil_1 = require("../util/TextUtil");
const crm_components_1 = require("crm-components");
class TranslateStore {
    constructor(rootStore) {
        Object.defineProperty(this, "translations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "globalTranslateAppName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'global'
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (key, paramObject) => this.getTranslationForGroup(TranslateStore.defaultTranslateAppName, key, paramObject)
        });
        Object.defineProperty(this, "getTranslationForGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (group, key, paramObject) => {
                const groupTranslations = this.translations[group];
                let textValue;
                if (groupTranslations) {
                    textValue = groupTranslations[key];
                }
                if (textValue) {
                    if (paramObject) {
                        return (0, TextUtil_1.parseTextParams)(textValue, paramObject);
                    }
                    return textValue;
                }
                return `${group}:${key}`;
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.ssoStore = rootStore.ssoStore;
        this.fetchTranslations((0, crm_components_1.getCurrentLanguage)());
    }
    get currentTranslations() {
        return this.translations;
    }
    get globalTranslations() {
        return this.translations[this.globalTranslateAppName];
    }
    fetchTranslations(language) {
        return ApiUtil_1.default.get(`/translations/${language}`)
            .then((0, mobx_1.action)((response) => (this.translations = response.data.translations || {})))
            .catch((e) => {
            console.error(e);
        });
    }
}
Object.defineProperty(TranslateStore, "defaultTranslateAppName", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'brandfreeweb'
});
__decorate([
    mobx_1.observable
], TranslateStore.prototype, "translations", void 0);
__decorate([
    mobx_1.computed
], TranslateStore.prototype, "currentTranslations", null);
__decorate([
    mobx_1.computed
], TranslateStore.prototype, "globalTranslations", null);
exports.default = TranslateStore;
